import { MuiButton } from './button';
// override css for component
export const components = {
    MuiButton
//   we can add multiple component
  }